import { Routes } from '@angular/router';

import { SessionTokenGuard } from '../../shared/router/guard/session';
import { AdminComponent } from './component/admin.component';
import { AdminApiKeyListComponent } from './component/apikey/list/list.component';
import { CampaignStatsComponent } from './component/campaign-stats/campaign-stats.component';
import { AdminCampaignFormComponent } from './component/campaign/form/form.component';
import { AdminCampaignListComponent } from './component/campaign/list/list.component';
import { AdminCustomeCameraSettingsTableComponent } from './component/customer/camera-settings/table.component';
import { AdminCustomerCampaignListComponent } from './component/customer/campaign/campaign.component';
import { AdminCustomerFormComponent } from './component/customer/form/form.component';
import { AdminCustomerInvoiceComponent } from './component/customer/invoice/invoice.component';
import { AdminCustomerLicenseComponent } from './component/customer/license/license.component';
import { AdminCustomerListComponent } from './component/customer/list/list.component';
import { AdminCustomerPaymentComponent } from './component/customer/payment/payment.component';
import { AdminCustomerTabsComponent } from './component/customer/tabs/tabs.component';
import { AdminCustomerUserFormComponent } from './component/customer/user/form.component';
import { AdminCustomerUserListComponent } from './component/customer/user/list.component';
import { AdminCustomerUserComponent } from './component/customer/user/user.component';
import { AdminJobListComponent } from './component/job/list/list.component';
import { AdminLicenseListComponent } from './component/license/list/list.component';
import { AdminMailTemplateListComponent } from './component/mail-template/list/list.component';
import { AdminPaymentDetailsComponent } from './component/payment/details/details.component';
import { AdminPaymentListComponent } from './component/payment/list/list.component';
import { AdminPhotocodeTemplateFormComponent } from './component/photocode-template/form/form.component';
import { AdminPhotocodeTemplateListComponent } from './component/photocode-template/list/list.component';
import { AdminPhotographerListComponent } from './component/photographer/list/list.component';
import { AdminProductListComponent } from './component/product/list.component';
import { AdminSolvimonEventListComponent } from './component/solvimon-event/list/list.component';
import { SolvimonTabsComponent } from './component/solvimon-tabs/solvimon-tabs.component';
import { AdminUserFormComponent } from './component/user/form/form.component';
import { AdminUserListComponent } from './component/user/list/list.component';
import { WebsiteRedirectListComponent } from './component/website-redirect/list/list.component';
import { AdminInventoryComponent } from './component/invetory/component/inventory.component';
import { AdminInventoryListComponent } from './component/invetory/component/inventory-list/inventory-list.component';
import { AdminPrintCreditListComponent } from './component/print-credit/component/print-credit-list/print-credit-list.component';
import { AdminPrintCreditComponent } from './component/print-credit/component/print-credit.component';

export const AdminRoutes: Routes = [
    {
        path: 'admin',
        component: AdminComponent,
        canActivate: [SessionTokenGuard],
        children: [
            {
                path: '',
                pathMatch: 'full',
                redirectTo: 'accounts',
            },
            {
                path: 'campaign',
                component: AdminCampaignListComponent,
                children: [
                    {
                        path: 'new',
                        component: AdminCampaignFormComponent,
                    },
                    {
                        path: ':id',
                        component: AdminCampaignFormComponent,
                    },
                ],
            },
            {
                path: 'products',
                component: AdminProductListComponent,
            },
            {
                path: 'photographers',
                component: AdminPhotographerListComponent,
            },
            {
                path: 'api-keys',
                component: AdminApiKeyListComponent,
            },
            {
                path: 'accounts',
                component: AdminCustomerListComponent,
            },
            {
                path: 'redirects',
                component: WebsiteRedirectListComponent,
            },
            {
                path: 'solvimon',
                component: SolvimonTabsComponent,
                children: [
                    {
                        path: 'event',
                        component: AdminSolvimonEventListComponent,
                    },
                ],
            },
            {
                path: 'account/:id',
                component: AdminCustomerTabsComponent,
                children: [
                    {
                        path: 'settings',
                        component: AdminCustomerFormComponent,
                    },
                    {
                        path: 'license',
                        component: AdminCustomerLicenseComponent,
                    },
                    {
                        path: 'payment',
                        component: AdminCustomerPaymentComponent,
                    },
                    {
                        path: 'invoice/:id',
                        component: AdminCustomerInvoiceComponent,
                    },
                    {
                        path: 'campaigns',
                        component: AdminCustomerCampaignListComponent,
                    },
                    {
                        path: 'users',
                        component: AdminCustomerUserComponent,
                        children: [
                            {
                                pathMatch: 'full',
                                path: '',
                                component: AdminCustomerUserListComponent,
                            },
                            {
                                path: ':id',
                                component: AdminCustomerUserFormComponent,
                            },
                            {
                                path: 'new',
                                component: AdminCustomerUserFormComponent,
                            },
                            {
                                path: 'camera-settings/:photographer',
                                component: AdminCustomeCameraSettingsTableComponent,
                            },
                        ],
                    },
                ],
            },
            {
                path: 'payment',
                component: AdminPaymentListComponent,
                children: [
                    {
                        path: ':customerId',
                        component: AdminPaymentDetailsComponent,
                    },
                ],
            },
            {
                path: 'user',
                component: AdminUserListComponent,
                children: [
                    {
                        path: 'new',
                        component: AdminUserFormComponent,
                    },
                    {
                        path: ':id',
                        component: AdminUserFormComponent,
                    },
                ],
            },
            {
                path: 'photocode-template',
                component: AdminPhotocodeTemplateListComponent,
                children: [
                    {
                        path: 'new',
                        component: AdminPhotocodeTemplateFormComponent,
                    },
                    {
                        path: ':id',
                        component: AdminPhotocodeTemplateFormComponent,
                    },
                ],
            },
            {
                path: 'mail-template',
                component: AdminMailTemplateListComponent,
            },
            {
                path: 'license',
                component: AdminLicenseListComponent,
            },
            {
                path: 'jobs',
                component: AdminJobListComponent,
            },
            {
                path: 'stats',
                component: CampaignStatsComponent,
            },
            {
                path: 'print-credits',
                component: AdminPrintCreditComponent,
                children: [
                    {
                        path: '',
                        component: AdminPrintCreditListComponent
                    }
                ]
            },
            {
                path: 'inventory',
                component: AdminInventoryComponent,
                children: [
                    { path: '', redirectTo: 'list', pathMatch: 'full' },
                    {
                        path: 'list',
                        component: AdminInventoryListComponent,
                        data: { title: 'Inventory List' },
                    },
                ],
            },
        ],
    },
];
